import type { SVGProps } from 'react';

const SvgLoadDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 11c-.55 0-1 .45-1 1v4c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-4c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M15.29 9.29 13 11.58V4c0-.55-.45-1-1-1s-1 .45-1 1v7.59L8.71 9.3c-.2-.2-.45-.29-.71-.29s-.51.1-.71.29a.996.996 0 0 0 0 1.41l4 4c.39.39 1.02.39 1.41 0l4-4a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgLoadDown;
